module.exports = __webpack_public_path__ + "4008a001e411134d4f192a0e4e055539.jpg";